import Axios from 'axios';
import React, { createContext, useContext } from 'react';
import { useAuth0 } from './Auth0Provider';

const baseURL = process.env.REACT_APP_API_HOSTNAME;

export const AxiosContext = createContext(undefined);

const AxiosProvider = ({ children }) => {
  const axios_client = Axios.create({
    baseURL,
    headers: {
      'Content-Type': 'application/json',
    },
  });
  const { getTokenSilently, getTokenWithPopup } = useAuth0();

  axios_client.interceptors.request.use(async (config) => {
    let token;
    try {
      token = await getTokenSilently();
    } catch (err) {
      token = await getTokenWithPopup();
    }
    if (token) {
      // eslint-disable-next-line no-param-reassign
      config.headers.Authorization = `Bearer ${token}`;
    }

    return config;
  });

  return (
    <AxiosContext.Provider value={axios_client}>
      {children}
    </AxiosContext.Provider>
  );
};

export default AxiosProvider;

export function useAxios() {
  return useContext(AxiosContext);
}
